import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import logService from './services/logService';

// Global error handlers
window.onerror = (message, source, lineno, colno, error) => {
  logService.error(`Uncaught error: ${message}`, {
    source: `${source}:${lineno}:${colno}`,
    stack: error?.stack,
  });
};

window.addEventListener('unhandledrejection', (event) => {
  logService.error(`Unhandled promise rejection: ${event.reason}`, {
    source: 'unhandledrejection',
    stack: event.reason?.stack,
  });
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
